'use client'

import { CenteredLoader } from '@/components/ui/loading'
import useStorage from '@/hooks/use-storage'
import { USER_AUTH_STORAGE_KEY } from '@/hooks/use-storage/use-storage.constants'
import { isUserSessionValid } from '@/lib/user/auth'

import BusinessSelectionPage from './business-selection/page'
import Login from './login/page'

export default function HomePage() {
  const { value: user, storageLoaded } = useStorage(USER_AUTH_STORAGE_KEY)

  if (!storageLoaded) {
    return <CenteredLoader message="Loading your account details..." />
  }

  if (!isUserSessionValid(user as object)) {
    return <Login />
  }

  return <BusinessSelectionPage />
}
